export const DEAL_RENT_TRAP_MAINPAGE = 'deal_rent_trap_mainpage';

export const EXPERIMENTS = [DEAL_RENT_TRAP_MAINPAGE];
